import isPropValid from '@emotion/is-prop-valid';

export const shouldForwardProp = (propName: string, target: unknown): boolean => {
	if (typeof target === 'string') {
		return isPropValid(propName);
	}
	return true;
};
